<template>
  <div
    class="advanced-search-container as-content as-content-1 active mobile-responsive"
  >
    <ValidationObserver
      ref="formValidator"
      v-slot="{
        invalid,
        touched,
        valid,
      }"
    >
      <div class="row">
        <div class="col-12">
          <form novalidate @submit.prevent="handleSubmit">
            <div class="form-group">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="(nombre)"
              >
                <CustomInput
                  id="txtAdvancedStudentSearchFirstName"
                  v-model="input.firstName"
                  required
                  placeholder="Nombre*"
                  :error="errors[0]"
                  :custom-error-msg.sync="errors[0]"
                  @keypress="onKeyPressed($event)"
                />
              </ValidationProvider>
            </div>
            <div class="form-group">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="(apellido)"
              >
                <CustomInput
                  id="txtAdvancedStudentSearchLastName"
                  v-model="input.lastName"
                  required
                  placeholder="Apellido*"
                  :error="errors[0]"
                  :custom-error-msg.sync="errors[0]"
                  @keypress="onKeyPressed($event)"
                />
              </ValidationProvider>
            </div>
            <div class="form-group" @keypress.enter.prevent="search()">
              <ValidationProvider
                v-slot="{ errors }"
                name="(fecha de nacimiento)"
              >
                <CustomDatePicker
                  id="dpAdvancedStudentSearchBirthDate"
                  v-model="input.birthDate"
                  placeholder="Fecha de Nacimiento"
                  class-container="w-100"
                  @keypress="onKeyPressed($event)"
                  @onSelectedDate="onSelectedDate"
                />
              </ValidationProvider>
            </div>
            <div class="form-group">
              <ValidationProvider v-slot="{ errors }" name="(impedimento)">
                <v-select
                  id="ddlAdvancedStudentSearchImpediment"
                  v-model="input.primaryImpediment"
                  class="v-select-extended"
                  label="name"
                  :reduce="(opt) => opt.name"
                  item-value="name"
                  :options="impedimentList"
                  placeholder="Impedimento"
                  @search:blur="changedValueDropDown($event)"
                />
              </ValidationProvider>
            </div>
            <div class="form-group">
              <ValidationProvider
                v-slot="{ errors }"
                name="(código de escuela)"
              >
                <input
                  id="txtAdvancedStudentSearchSchoolCode"
                  ref="schoolInput"
                  v-model="input.schoolCode"
                  type="text"
                  class="form-control"
                  :class="{ invalid: errors.length > 0 }"
                  placeholder="Código de escuela"
                  @keypress="onKeyPressed($event)"
                />
              </ValidationProvider>
            </div>
            <div class="form-group">
              <ErrorComponent
                v-if="recordsNotFound"
                message="Su búsqueda no generó resultados."
              />
            </div>
            <div class="form-group">
              <button
                id="btnAdvancedStudentSearch"
                type="button"
                class="btn btn-success-softer search-action-button float-lg-right"
                @click="search()"
              >
                Buscar
              </button>
            </div>
          </form>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<style scoped>
.advanced-search-container {
  background: #f2f2f2;
  /* padding: 10px; */
}
</style>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/es.json';

import mixAlert from '@/mixin/alert.mixin';
import CustomInput from '@/components/common/CustomInput';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import ErrorComponent from '@/components/common/Error';

import 'vue-select/dist/vue-select.css';

Object.keys(rules).forEach((rule) => {
  let ruleObj = {
    ...rules[rule], // copies rule configuration
    message: messages[rule], // assign message
  };
  extend(rule, ruleObj);
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,

    CustomInput,
    CustomDatePicker,
    ErrorComponent,
  },
  props: {
    recordsNotFound: {
      type: Boolean,
    },
    onSearch: {
      type: Function,
    },
    impedimentList: {
      type: Array,
      default: function() {
        return [];
      },
    },
    currentSearch: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  mixins: [mixAlert],
  data() {
    return {
      input: {
        firstName: '',
        lastName: '',
        birthDate: null,
        primaryImpediment: '',
        schoolCode: '',
        pageIndex: 1,
        pageSize: 5,
      },
    };
  },
  methods: {
    onKeyPressed(event) {
      if (event.keyCode === 13) {
        this.search();
      }
    },
    changedValueDropDown() {
      this.$refs.schoolInput.focus();
    },
    async validate() {
      return await this.$refs.formValidator.validate();
    },
    async search() {
      let isValid = await this.validate();

      if (!isValid) return;

      this.onSearch(this.input);
    },
    setSelectedImpediment(value) {
      this.input.primaryImpediment = value.name;
    },
    onSelectedDate(date) {
      if (date) {
        this.input.birthDate = date;
      }
    },
  },
  created() {
    if (this.currentSearch) {
      this.input = { ...this.input, ...this.currentSearch };
    }
  },
};
</script>
